module.exports = __webpack_public_path__ + "static/media/disabledHorizontalEventIcon.65a2f799.svg";